import { slideDown, slideUp } from "../../../assets/src/js/main/helpers.js";

document.querySelectorAll(".kdv-faq-item").forEach((details) => {
	const summary = details.querySelector(".kdv-faq-item__question");
	const answer = details.querySelector(".kdv-faq-item__answer");

	if (!summary || !answer) return;

	summary.addEventListener("click", (e) => {
		e.preventDefault();

		if (details.open) {
			slideUp(answer);
			setTimeout(() => details.removeAttribute("open"), 300);
		} else {
			details.setAttribute("open", "");
			answer.style.display = "none";
			slideDown(answer);
		}
	});
});
